import { useState } from "react";

export const useExcelDownloadHook = () => {
    const [isDown, setIsDown] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [updateParams, setUpdateParams] = useState({
        downreason: '',
        bigo: '',
    });

    const handleUpdateInputChange = (e) => {
        const { name, value } = e.target;
        setUpdateParams(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const openModal = () => {
        setIsModalOpen(true);
        setIsDown(false);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const openConfModal = () => {
        setUpdateParams(prev => ({
            ...prev,
            downreason: '',
            bigo: ''
        }));
        openModal();
    };

    return {
        isModalOpen,
        isDown,
        updateParams,
        openModal,
        openConfModal,
        closeModal,
        handleUpdateInputChange,
        setIsDown,
    };
};